<div class="input-group">
  <select [ngClass]="className" (change)="handleOnProvinceChange($event)" (focus)="onTouched()" [disabled]="isDisabled">
    <option disabled hidden>-- Select a province --</option>
    <option *ngFor="let province of provincesList" [value]="province.id" [selected]="isSelectProvince(province.id)">{{province.name}}</option>
  </select>
  <select [ngClass]="className" (change)="handleOnDistrictChange($event)" (focus)="onTouched()" [disabled]="isDisabled">
    <option disabled hidden>-- Select a district --</option>
    <option *ngFor="let district of districtsList" [value]="district.id" [selected]="isSelectDistrict(district.id)">{{district.name}}</option>
  </select>
  <select [ngClass]="className" (change)="handleOnCommuneChange($event)" (focus)="onTouched()" [disabled]="isDisabled">
    <option disabled hidden>-- Select a commune --</option>
    <option *ngFor="let commune of communesList" [value]="commune.id" [selected]="isSelectCommune(commune.id)">{{commune.name}}</option>
  </select>
</div>
